module.exports = __webpack_public_path__ + "assets/Clock.aaf723c1.svg";